export function toDecimal(value: number, decimalPoints = 2) {
	return Math.round((Number.EPSILON + value) * Math.pow(10, decimalPoints)) / Math.pow(10, decimalPoints);
}

export function percentageOf(valueA: number, valueB: number) {
	return toDecimal((valueA / valueB) * 100);
}
